/**
 * Split fortnight API `days` (chronological) into Mon-aligned week chunks (7 days each).
 */
export function splitAvailabilityIntoWeeks(days) {
  if (!Array.isArray(days) || days.length === 0) return [];
  const weeks = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }
  return weeks;
}

function dayHasHourlySlots(d) {
  return Array.isArray(d?.time_slots) && d.time_slots.length > 0;
}

/**
 * @param {Array<{ date: string, editable?: boolean, is_past?: boolean, time_slots?: string[] }>|undefined} days
 * @returns {{ show: boolean, variant: 'never' | 'new_week' | null }}
 */
export function computeAvailabilityReminder(days) {
  if (!Array.isArray(days) || days.length === 0) {
    return { show: false, variant: null };
  }
  const editable = days.filter((d) => d && d.editable && !d.is_past);
  if (editable.length === 0) {
    return { show: false, variant: null };
  }
  const hasAnyHourly = editable.some(dayHasHourlySlots);
  if (!hasAnyHourly) {
    return { show: true, variant: 'never' };
  }
  const weeks = splitAvailabilityIntoWeeks(days);
  if (weeks.length < 2) {
    return { show: false, variant: null };
  }
  const lastWeek = weeks[weeks.length - 1];
  const lastEditable = lastWeek.filter((d) => d && d.editable && !d.is_past);
  if (lastEditable.length === 0) {
    return { show: false, variant: null };
  }
  const lastWeekHasHourly = lastEditable.some(dayHasHourlySlots);
  if (!lastWeekHasHourly) {
    return { show: true, variant: 'new_week' };
  }
  return { show: false, variant: null };
}
